<div class="phone-info {{ class }}" *ngIf="phone">
  <div class="iti-flag" [ngClass]="phoneCountry"></div>
  <a draggable="false" href="tel:{{ phone }}" class="phone-info-value" [title]="formatPhoneNumber()">{{
    formatPhoneNumber()
  }}</a>
</div>
<span *ngIf="!phone">-</span>
